import { render, staticRenderFns } from "./token-dialog.vue?vue&type=template&id=4358a338&"
import script from "./token-dialog.vue?vue&type=script&lang=js&"
export * from "./token-dialog.vue?vue&type=script&lang=js&"
import style0 from "./token-dialog.vue?vue&type=style&index=0&id=4358a338&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports